export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12790.6380e766.jpg";